<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col class="pa-2" cols="12" md="4">
          <div class="sticky-md" style="top: 110px">
            <qr-maker />
            <v-card-actions class="justify-center">
              <div
                class="rowinfo"
                style="
                  justify-content: center !important;
                  align-items: center !important;
                "
              >
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-download`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  class="buttoninfo"
                  label="دانلود کیوآر"
                  style="
                    padding: unset !important;
                    align-self: center !important;
                  "
                />
              </div>
            </v-card-actions>
          </div>
        </v-col>

        <v-col class="pa-8" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>ورود اطلاعات</p>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="visitName"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام کیوآر"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName`"
                      :help-data="helpData"
                      :service-name="serviceName"
                      class="buttoninfo"
                      label="نام کیوآر"
                    />
                  </div>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <qr-address-field
                      v-model="dtUrl"
                      :disabled="e6 > 1"
                      append-icon="mdi-web"
                      class="mt-0 pt-0 contentinfo"
                      dense
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"
                      outlined
                      persistent-hint
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dturl`"
                      :help-data="helpData"
                      :service-name="serviceName"
                      class="buttoninfo"
                      label="آدرس کیوآر"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion icon="link" single title="لینک">
                <template v-slot:content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="identifier"
                        :rules="urlRules"
                        append-icon="mdi-link"
                        class="rowinfo"
                        dense
                        hint="terminalads.com"
                        label="لینک"
                        outlined
                        placeholder="لینک موردنظر خودرا وارد کنید."
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-data-link`"
                        :help-data="helpData"
                        :service-name="serviceName"
                        class="buttoninfo"
                        label="لینک"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="title"
                        append-icon="mdi-pencil"
                        class="rowinfo"
                        dense
                        label="نام لینک"
                        outlined
                        placeholder="نام لینک موردنظر خودرا وارد کنید."
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-data-link`"
                        :help-data="helpData"
                        :service-name="serviceName"
                        class="buttoninfo"
                        label="لینک"
                      />
                    </v-col>
                  </v-row>
                </template>
              </list-expansion>

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate"
                >
                  ویرایش
                </next-btn>
              </div>
            </v-stepper-content>
            <div class="d-none">
              <v-stepper-step
                v-if="qrType"
                :complete="e6 > 2"
                class="px-0 px-md-4"
                step="2"
                >تنظیمات کیوآر
              </v-stepper-step>
              <v-stepper-content
                v-if="qrType"
                class="pr-1 mx-0 mr-md-7 px-md-4"
                step="2"
              >
                <qr-management :data="data" />
                <div class="row mx-auto">
                  <div class="col-md-6">
                    <prev-btn :loading="loading" @click="e6 = 1" />
                  </div>

                  <div class="col-md-6">
                    <!--              <next-btn :loading="loading" @click="setSettings"/>-->
                  </div>
                </div>
              </v-stepper-content>
              <div claass="d-none">
                <v-stepper-step
                  :complete="qrType ? e6 > 3 : e6 > 2"
                  :step="qrType ? 3 : 2"
                  class="px-0 px-md-4"
                >
                  دیزاین کیوآر
                </v-stepper-step>
                <v-stepper-content
                  :step="qrType ? 3 : 2"
                  class="pr-1 mx-0 mr-md-7 px-md-4"
                >
                  <!--          <qr-customize v-model="qrDesign"/>-->
                  <qr-code-make
                    ref="qrCanvas"
                    v-model="qrDesign"
                    :file.sync="qrSvgDataUrl"
                    :link="data.link"
                    @save="qrDesign = $event"
                  />
                  <div class="row mx-auto">
                    <!--            <div class="col-md-6">-->
                    <!--              <prev-btn :loading="loading" text="ویرایش" style="background: orange"-->
                    <!--                        @click="goto(`qr/${createdId}/edit`)" v-if="finish"/>-->

                    <!--&lt;!&ndash;              <prev-btn :loading="loading" @click="e6 = 2" v-else/>&ndash;&gt;-->
                    <!--            </div>-->

                    <div class="col-md-12">
                      <div class="rowinfo">
                        <v-btn
                          v-if="data.svg"
                          class="btn-download float-left"
                          @click="showDialog = true"
                        >
                          <v-icon>mdi-progress-download</v-icon>
                          {{ $t("download_qr") }}                        </v-btn>
                        <help-info
                          :element-name="`${serviceName}-${componentName}-download_qr`"
                          :help-data="helpData"
                          :service-name="serviceName"
                          class="buttoninfo"
                          label="دانلود کیوآر"
                        />
                      </div>
                    </div>
                  </div>
                </v-stepper-content>
              </div>
            </div>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: 'دانلود کیوآر' }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-download-Qr-d`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>

          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${data?.domain?.name||'qrland.in/'}${data?.identifier}`"
              :visit-name="visitName"
              @close="showDialog = false"
              :qr_id="data?.qrId.replace('?gateway=true','')"
              :is-qrlink="true"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrCodeMake from "./qrCodeStyle/qrCodeMake.vue";
import QrMaker from "./components/qrMaker.vue";
import QrManagement from "./components/qrManage/qrManagement.vue";
import ListExpansion from "../../content/fragments/listExpansion.vue";
import NextBtn from "../../content/fragments/nextBtn.vue";
import PrevBtn from "../../content/fragments/prevBtn.vue";
import QrAddressField from "../../content/fragments/qrAddressField.vue";
import { debounce } from "../../../main";
import { mapActions } from "vuex";
import DownloadFileWithApi from "./downloadFileWithApi.vue";

export default {
  name: "qrLink",

  components: {
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    QrMaker,
    QrCodeMake,
    DownloadFileWithApi,
  },

  data() {
    return {
      qr_id: 0,
      helpData: [],
      serviceName: "Qrland",
      componentName: "qrLink",
      info: {},
      qrSvgDataUrl: "",
      identifier: "",
      qrType: false,
      showDialog: false,
      editable: false,
      createdId: "",
      loading: false,
      finish: false,
      dtUrl: null,
      e6: 1,
      visitName: "لینک",
      urlRules: [
        (value) =>
          this.isURL(value) ||
          "لینک سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      ],
      title: "",
      data: {
        link: "example.com",
        shortLink: "",
        svg: "",
      },
      cons: { title: "دانلود کیوآر" },
      qrDesign: null,
    };
  },

  mounted() {
    this.fetchData();
    let newUrl = this.$route.fullPath.replace(/\/qr\/link\//g, "")?.replace('?gateway=true','');
  },

  computed: {
    domainName() {
      return this.$route.fullPath?.replace(/\/qr\/link\//g, "")?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    qrlink() {
      return this.$route.params.name?.replace('?gateway=true','') || "";
    },
  },

  watch: {
    "data.link"(val) {
      debounce(() => {
        this.updateQr();
      }, 500);
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    fetchData() {
      this.loading = true;
      this.$api
        .get(`/v1/testQr/find1/${this.domainName}`)
        .then(({ data }) => {
          this.data.link = data.data.link;
          this.identifier = data.data.identifier
            ?.trim()
            ?.replace(/https?:\/\/+/i, "");
          this.title = data.data.title;
          this.qrDesign = data.data.qr;
          this.qrSvgDataUrl = data.data.image;
          this.qr_id = data.data.qrId; ///
        })
        .finally(() => (this.loading = false));
    },

    qrUpdate() {
       if (!this.identifier || !this.isURL(this.identifier)) {
          return this.$toast.error("لینک سایت باید بصورت http:// یا https:// وارد شود.");
        }
      this.loading = true;

      const data = new FormData();
      data.append("type", "qrLink");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("identifier", this.identifier);
      data.append("title", this.title);
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append("qr_id", this.domainName); ///

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: "",
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          this.$toast.success("کیوآر بیزنس پیج شما باموفقیت ویرایش شد.");
          if (this.e6 === 1) {
            this.$router.push(`/qr/list`);
            setTimeout(() => {
              this.$refs.qrCanvas.appendCanvas(this.info.link);
            }, 500);
            setTimeout(() => {
              // this.qrUpdate();
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateQr() {
      setTimeout(() => {
        this.$refs.qrCanvas.appendCanvas(this.data.link);
      }, 500);
    },
     isURL(str) {
      if(!str) return false;
      try {
      const url = new URL(str);
      const res1= url.protocol === "http:" || url.protocol === "https:";
      const regex = /^(https?:\/\/)([a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})+)[^\s]*$/;
      const rest2 = regex.test(str.trim());
      return rest2 && res1;

      } catch (err) {
        return false;
      }
    },
  },
};
</script>

<style scoped></style>
